/* eslint-disable react-hooks/exhaustive-deps */
import { Dropdown, DropdownToggle, DropdownMenu } from "@ht/components";
import clsx from "clsx";
import MenuHeader from "./menu-header";
import DropddownItem from "./item";
import MessageSquareDotIcon from "@ht/shared/fonts/deos-pis/message-square-dot";
import { FC, useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import { nanoid } from "nanoid";
import { IMessage } from "../../../app/chatAgent/types";
import { useNavigate } from "react-router-dom";
import { useHttpRequest } from "../../../hooks/useHttpRequest";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  activeChatAgentRoom,
  readAgentMessage,
  unreadAgentNotification,
  setLayoutType,
  startAgentChat
} from "../../../app/chatAgent/chatAgentSlice";
import { setLeftPanelLeads } from "../../../app/layout/layoutStateSlice";
import defaultProfilePicture from "@ht/shared/images/img1.jpg";
import FloatingChat from "../../../pages/agent-monitoring/components/FloatingChat";

const NotificationInternalDropdown: FC = () => {
  const dispatch = useAppDispatch();
  const { user } = useAppSelector((state) => state.auth);
  const { callState } = useAppSelector((state) => state.call);
  const { notifications } = useAppSelector((state) => state.chatagent);
  const navigate = useNavigate();
  const { sendRequest } = useHttpRequest();
  const [isOpen, setIsOpen] = useState(false)


  useEffect(() => {
    const getUnreadNotification = async () => {
      const unReadChatUrl = `/UnreadChat/${user?.username}/?limit=3`;
      const chatBaseUrl = String(process.env.REACT_APP_CHAT_AGENT_SERVICE);

      const { data } = await sendRequest({
        baseUrl: chatBaseUrl,
        url: unReadChatUrl,
        method: "get",
      });

      if (data) {
        const messages = data?.map((item: any) => ({
          roomId: item.room_id,
          messageId: item.message_id,
          message: item.message,
          messageType: item.message_type,
          messageTime: item.message_time,
          minMessageTime: item.min_message_time,
          messageFiles: item.message_files,
          messageRead: item.message_read,
          roomOwner: item.room_owner,
          senderId: item.sender_id,
          senderName: item.sender_name,
          avatar: { src: defaultProfilePicture },
          sessionId: item.session_id,
          participant: item.participant,
          isSent: true,
        }));

        dispatch(unreadAgentNotification(messages));
      }
    };

    if (user?.username) {
      getUnreadNotification().catch((err) => console.log(err));
    }
  }, []);

  const showAllHandler = () => {
    if (callState.isCalling) dispatch(setLeftPanelLeads("CHAT_AGENT"));
    else navigate("/chat");
  };

  const unreadMessages = useMemo(() => {
    const filterResult = notifications.filter(
      (a) =>
        a.message != "" &&
        a.participant?.includes(user?.username ?? "") &&
        a.senderName != user?.username
    );
    const results = [...filterResult].sort(
      (a, b) =>
        new Date(
          dayjs(b.messageTime).format("YYYY-MM-DD HH:mm:ss.SSS")
        ).getTime() -
        new Date(
          dayjs(a.messageTime).format("YYYY-MM-DD HH:mm:ss.SSS")
        ).getTime()
    );

    return results.filter((_item, idx) => idx <= 2);
  }, [notifications]);

  const notificationClickHandler = (message: IMessage) => {
    const roomId = message.roomId;
    dispatch(readAgentMessage({ sessionId: message.sessionId, messageId: 0 }));
    const activeChatObj = {
      userName: message.senderName,
      roomId,
      sessionId: message.sessionId,
    };
    localStorage.setItem("activeChatRoom", JSON.stringify(activeChatObj));
    if (callState.isCalling) {
      dispatch(setLeftPanelLeads("CHAT_AGENT"));
      dispatch(activeChatAgentRoom(activeChatObj));
    } 
    else {
      dispatch(setLayoutType("FLOATING_PANEL"));
      const receiverObj = {
          toUserName: message.senderName,
          tenantId: user?.tenantId
      }
      dispatch(startAgentChat(receiverObj));
      setIsOpen(true);
    } 
  };

  function closeModal() {
    setIsOpen(false)
  }

  return (
    <Dropdown direction="down" showIcon={false} className="mt-[4px]" shape>
      <DropdownToggle
        variant="texted"
        iconButton
        size="lg"
        shape="ellipse"
        customStyle="only-icon"
        className="text-2xl !text-white hover:!text-primary w-[32px] h-[32px] pl-[1px] relative content-start"
      >
        <MessageSquareDotIcon
          className={clsx("w-[20px] h-[20px] ml-1.5")}
          fill="none"
        />
        {(unreadMessages?.length ?? 0) > 0 && (
          <span className="w-[7px] h-[7px] bg-success rounded-full absolute top-0 right-[2px]" />
        )}
      </DropdownToggle>
      <DropdownMenu
        className={clsx(
          "p-0 w-[14.75rem] rounded-lg sm:w-[17.875rem] mt-[1.125rem] -mr-[1rem] right-0 left-auto"
        )}
      >
        <MenuHeader />
        <div className="dropdown-list max-w-md">
          {unreadMessages?.map((item) => (
            <DropddownItem
              key={nanoid()}
              onClick={() => {
                notificationClickHandler(item);
              }}
              senderName={item.senderName}
              message={item.message}
              messageType={item.messageType}
              messageTime={item.messageTime}
            />
          ))}
        </div>
        <div className="dropdown-menu-footer text-center text-primary text-base px-[0.938rem] py-[0.625rem]">
          <button onClick={showAllHandler}>
            <i className="fa fa-angle-down" /> Show All Chats
          </button>
        </div>
        <FloatingChat isOpen={isOpen} closeModal={closeModal} />
      </DropdownMenu>
    </Dropdown>
  );
};
export default NotificationInternalDropdown;
